import React from 'react'
import { forwardRef, HTMLAttributes } from 'react'
import classNames from 'classnames'

interface PageBodyProps extends HTMLAttributes<HTMLDivElement|HTMLSpanElement> {
    className?: string
    // removes the default outer margin for full-bleed layouts
    flush?: boolean
}

const PageBody = forwardRef<HTMLDivElement, PageBodyProps>(({
    className,
    flush = false,
    children,
    ...otherProps
}, ref) => {

    const _className = classNames(
        'page-body animated',
        !flush && !className?.includes('landing-page') && 'm-4',
        className
    )

    return (
        <div
            ref={ref}
            className={_className}
            {...otherProps}>
            {children}
        </div>
    )
})

export default PageBody
PageBody.displayName = 'PageBody'
